﻿var jquery = require('jquery');
global.jQuery = global.$ = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly
var bootstrap = require('bootstrap');
var fancybox = require('@fancyapps/fancybox');
var topNavigation = require('./components/topNavigation');
var siteSearch = require('./components/siteSearch');
var contactFooter = require('./components/contactFooter');
var translationExpand = require('./components/translateFooter');
var socialOverlayExpand = require('./components/socialOverlayButton');

var lazyLoad = require('./components/lazyLoad');
var locationHighlight = require('./components/locationHighlight');
var popup = require('./components/popup');
var NewsletterModule = require('./components/newsletter');
//var loginPopup = require('./components/loginPopup');

$(function () {
    topNavigation.initialize();
    siteSearch.initialize();
    // translationExpand.init();
    contactFooter.init();
    lazyLoad.initialize();
    locationHighlight.initialize();
    NewsletterModule.init();
    popup.initialize();
    // loginPopup.initialize();
})
